const { onlyAlphaNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyAlphaNumeric(zipCode);

exports.countryDefinition = {
  country: 'Argentina',
  code: 'AR',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(
        /^[A-Za-z][0-9][0-9][0-9][0-9][A-Za-z][A-Za-z][A-Za-z]$/
      ),
      error: 'Must be 1 letter, 4 numbers, and 3 letters, Y5900FNF'
    }
  ]
};
